import { DefaultState } from '@src/redux/types'

import { GUEST_ALL, GUEST_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [GUEST_LIST]: DefaultState<`${typeof API.USER_GUEST}`, 'get'>
  [GUEST_ALL]: DefaultState<`${typeof API.USER_GUEST_ALL}`, 'get'>
} = () => ({
  [GUEST_LIST]: defaultState(),
  [GUEST_ALL]: defaultState(),
})
